import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import { ElMessage } from 'element-plus'
import 'element-plus/dist/index.css'
import './assets/css/global.css'
import './assets/css/theme.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import axios from "axios"
import qs from "qs";
import md5 from "md5";

// 在创建应用之前设置错误处理
const originalError = console.error;

console.error = (...args) => {
  if (args[0] && typeof args[0] === 'string' &&
    args[0].includes('ResizeObserver')) {
    // 静默处理 ResizeObserver 错误
    return;
  }
  originalError.apply(console, args);
};

// 捕获全局错误
window.addEventListener('error', (event) => {
  if (event.message && event.message.includes('ResizeObserver')) {
    event.preventDefault();
    event.stopPropagation();
  }
});

// app.vue写在script里面  main.js写在app挂在完之后
const debounce = (fn, delay) => {
  let timer
  return (...args) => {
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(() => {
      fn(...args)
    }, delay)
  }
}
const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback) {
    callback = debounce(callback, 200);
    super(callback);
  }
}


const app = createApp(App)

// Vue 错误处理器
app.config.errorHandler = (err, vm, info) => {
  const errorMessage = err?.message || String(err)

  // 定义要忽略的错误类型
  const ignorePatterns = [
    /parameter 1 is not of type 'Element'/,
    /Failed to execute 'getComputedStyle'/,
    /is not a valid selector/,
    /Cannot read properties of null/
  ]

  // 检查是否应该忽略
  const shouldIgnore = ignorePatterns.some(pattern =>
    pattern.test(errorMessage)
  )

  if (shouldIgnore) {
    console.warn('[Vue Error Ignored]:', err.message, 'in', info)
    return // 忽略错误
  }

  // 处理其他重要错误
  console.error('[Vue Error]:', err)
  // 可以在这里发送错误到监控系统
}

// 全局 Promise 错误处理器
window.addEventListener('unhandledrejection', (event) => {
  const errorMessage = event.reason?.message || String(event.reason)

  if (errorMessage.includes("parameter 1 is not of type 'Element'")) {
    event.preventDefault()
    console.warn('Promise 错误已被屏蔽:', errorMessage)
  }
})

//全局配置ico
for (let i in ElementPlusIconsVue) {
  app.component(i, ElementPlusIconsVue[i])
}

//全局配置axios
axios.defaults.withCredentials = true
let _pendingLoginRedirect = false
axios.interceptors.request.use((config) => {
  const base = String(store.getters.baseurl || "").replace(/\/+$/, "")
  const url = config?.url
  if (typeof url !== "string" || !url) return config

  const apiPrefix = "/api"
  const baseApiPrefix = `${base}${apiPrefix}`

  if (url === baseApiPrefix || url.startsWith(`${baseApiPrefix}/`)) return config
  if (url === apiPrefix || url.startsWith(`${apiPrefix}/`)) return config

  if (base && (url === base || url.startsWith(`${base}/`))) {
    config.url = `${baseApiPrefix}${url.slice(base.length)}`
    return config
  }

  if (url.startsWith("/")) {
    config.url = `${apiPrefix}${url}`
  }
  return config
})
axios.interceptors.response.use((response) => {
  const data = response?.data
  const resVal = data && typeof data === "object" ? data.res : undefined
  if (data && typeof data === "object" && (resVal === "no auth" || resVal === "no_auth")) {
    data.res = "no"
  }
  const normalizedResVal = data && typeof data === "object" ? data.res : resVal
  const isNoAuth = normalizedResVal === "no"
  const status = response?.status
  const isHttpNoAuth = status === 401 || status === 403
  if ((isNoAuth || isHttpNoAuth) && !_pendingLoginRedirect) {
    try {
      if (router?.currentRoute?.value?.path !== "/login") {
        ElMessage.warning("登录已过期，请重新登录")
      }
    } catch (e) { }
    _pendingLoginRedirect = true
    setTimeout(() => {
      _pendingLoginRedirect = false
      if (router?.currentRoute?.value?.path !== "/login") {
        router.push({ path: "/login" })
      }
    }, 2000)
  }
  return response
}, (error) => {
  const status = error?.response?.status
  if ((status === 401 || status === 403) && !_pendingLoginRedirect) {
    try {
      if (router?.currentRoute?.value?.path !== "/login") {
        ElMessage.warning("登录已过期，请重新登录")
      }
    } catch (e) { }
    _pendingLoginRedirect = true
    setTimeout(() => {
      _pendingLoginRedirect = false
      if (router?.currentRoute?.value?.path !== "/login") {
        router.push({ path: "/login" })
      }
    }, 2000)
  }
  return Promise.reject(error)
})
app.config.globalProperties.axios = axios

//全局绑定qs
app.config.globalProperties.qs = qs

app.config.globalProperties.md5 = md5;

app.use(ElementPlus)

app.use(store).use(router).mount('#app')
